import React from "react";
import { X, Search, User, Mail, Phone } from "lucide-react";

export default function ProcurementVendorModal({
  isOpen,
  onClose,
  vendorName,
  vendorObj,
  changing,
  setChanging,
  vendorSearch,
  setVendorSearch,
  filteredVendors,
  onChangeVendor
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: "520px" }}>
        <div className="modal-header">
          <h3>Vendor Details</h3>
          <button className="modal-close-btn" onClick={onClose}>
            <X size={18} />
          </button>
        </div>
        <div style={{ padding: "1.5rem" }}>
          {!changing ? (
            <>
              {vendorObj ? (
                <>
                  <div className="vendor-detail-card">
                    <h4 className="vendor-detail-name">{vendorObj.name}</h4>
                    {vendorObj.category && <span className="vendor-detail-category">{vendorObj.category}</span>}
                    {vendorObj.address && (
                      <p className="vendor-detail-address">
                        {vendorObj.address}{vendorObj.address2 ? `, ${vendorObj.address2}` : ""}<br />
                        {[vendorObj.city, vendorObj.state, vendorObj.zip].filter(Boolean).join(", ")}
                      </p>
                    )}
                  </div>

                  {vendorObj.pocs && vendorObj.pocs.length > 0 ? (
                    <div style={{ marginBottom: "1.5rem" }}>
                      <span className="procurement-modal-label" style={{ marginBottom: "0.75rem" }}>Points of Contact</span>
                      <div className="vendor-pocs-list">
                        {vendorObj.pocs.map((poc, pIdx) => (
                          <div key={pIdx} className="vendor-poc-card">
                            <div className="vendor-poc-name-row">
                              <User size={14} color="var(--primary)" />
                              <strong className="vendor-poc-name">{poc.name || "No Name"}</strong>
                              {poc.title && <span className="vendor-poc-title">— {poc.title}</span>}
                            </div>
                            {poc.email && (
                              <div className="vendor-poc-contact-row">
                                <Mail size={12} color="var(--text-secondary)" />
                                <a href={`mailto:${poc.email}`} className="vendor-poc-link">{poc.email}</a>
                              </div>
                            )}
                            {poc.phone && (
                              <div className="vendor-poc-contact-row">
                                <Phone size={12} color="var(--text-secondary)" />
                                <a href={`tel:${poc.phone}`} className="vendor-poc-link">{poc.phone}</a>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="procurement-empty-text" style={{ marginBottom: "1.5rem" }}>No points of contact on file.</div>
                  )}
                </>
              ) : (
                <div style={{ marginBottom: "1.5rem" }}>
                  <p className="procurement-empty-text">
                    {vendorName ? `Vendor "${vendorName}" not found in the system.` : "No vendor assigned to this item."}
                  </p>
                </div>
              )}

              <div className="procurement-modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setChanging(true)}>
                  Change
                </button>
                <button type="button" className="btn btn-primary" onClick={onClose}>
                  Close
                </button>
              </div>
            </>
          ) : (
            <>
              <div style={{ marginBottom: "1rem" }}>
                <label className="form-label">Search Vendors</label>
                <div style={{ position: "relative" }}>
                  <Search size={16} className="vendor-search-icon" />
                  <input
                    type="text"
                    className="form-input vendor-search-input"
                    placeholder="Type to search vendors..."
                    value={vendorSearch}
                    onChange={(e) => setVendorSearch(e.target.value)}
                    autoFocus
                  />
                </div>
              </div>

              <div className="vendor-select-list">
                {filteredVendors.length === 0 ? (
                  <p className="procurement-empty-text" style={{ textAlign: "center", padding: "1rem" }}>No vendors found.</p>
                ) : (
                  filteredVendors.map(v => (
                    <button
                      key={v.id}
                      onClick={() => onChangeVendor(v.name)}
                      className={`vendor-select-btn ${v.name === vendorName ? "vendor-select-active" : ""}`}
                    >
                      <span className="vendor-select-name">{v.name}</span>
                      {v.category && <span className="vendor-select-category">{v.category}</span>}
                    </button>
                  ))
                )}
              </div>

              <div className="procurement-modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setChanging(false)}>
                  Back
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
